import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "common-form-with-role-editor" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("สิทธิการเข้าใช้งาน")
const _hoisted_4 = { class: "text-gray-500 text-sm" }
const _hoisted_5 = {
  class: "mt-3 grid",
  style: {"grid-template-columns":"repeat(auto-fit, 280px)","grid-gap":"0.75rem"}
}
const _hoisted_6 = { class: "-mt-3 pt-3 text-right border-t" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, "บันทึก", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonModalWithPreset = _resolveComponent("CommonModalWithPreset")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonInputLabel = _resolveComponent("CommonInputLabel")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonForm = _resolveComponent("CommonForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CommonModalWithPreset, {
      ref: "doneModal",
      type: "success-close"
    }, null, 512),
    _createVNode(_component_CommonForm, { form: _ctx.form }, {
      default: _withCtx(() => [
        (_ctx.form.name === 'Super Admin')
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "ไม่สามารถแก้ไขสิทธิของ Super Admin ได้"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_CommonInput, {
                class: "mb-6",
                style: {"max-width":"260px"},
                label: "ชื่อกลุ่ม",
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                rules: "required|excluded:Super Admin,System Admin",
                validationErrorMessage: "จำเป็นต้องกรอก"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_CommonInputLabel, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (modulePerm) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mt-3 mb-6",
                  key: 'perm-group-' + modulePerm.module
                }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(('permissions' in modulePerm && modulePerm.permissions.length > 0) ? modulePerm.permissions[0].moduleDisplayName : modulePerm.module), 1),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulePerm.permissions, (perm) => {
                      return (_openBlock(), _createBlock(_component_CommonInput, {
                        key: 'perm-' + perm.name,
                        type: "checkbox",
                        value: _ctx.isSelectedList(perm),
                        onInput: ($event: any) => (_ctx.onSelect(perm, $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(perm.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onInput"]))
                    }), 128))
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CommonButton, { type: "submit" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}